import { IUserActions, IUserState } from './user.types'
import { UserConstants } from './user.constants'

export const initialUserState: IUserState = {
  authState: null,
  userId: '',
  userName: '',
  serviceId: '',
  serviceName: '',
  password: '',
  email: '',
  databaseUserName: '',
  userTypeData: null,
  userNameVerified: false,
  nowLoginAttemptedPostOkta: false,
  tempOktaAccessToken: '',
  privileges: [],
}

export function userReducer(state: IUserState = initialUserState, action: IUserActions): IUserState {
  switch (action.type) {
    case UserConstants.SET_AUTHORIZATION:
      return { ...state, authState: action.authState }
    case UserConstants.RESET_USER:
      return { ...initialUserState }
    case UserConstants.SET_USER_ID:
      return { ...state, userId: action.userId }
    case UserConstants.SET_USER_NAME:
      return { ...state, userName: action.userName }
    case UserConstants.SET_SERVICE:
      return { ...state, serviceId: action.serviceId, serviceName: action.serviceName }
    case UserConstants.SET_PASSWORD:
      return { ...state, password: action.password }
    case UserConstants.SET_EMAIL:
      return { ...state, email: action.email }
    case UserConstants.SET_DATABASE_USER_NAME:
      return { ...state, databaseUserName: action.databaseUserName }
    case UserConstants.SET_USER_TYPE_DATA:
      return { ...state, userTypeData: action.userTypeData }
    case UserConstants.SET_USER_NAME_VERIFIED:
      return { ...state, userNameVerified: action.userNameVerified }
    case UserConstants.SET_NOW_LOGIN_ATTEMPTED_POST_OKTA:
      return { ...state, nowLoginAttemptedPostOkta: action.nowLoginAttemptedPostOkta }
    case UserConstants.SET_TEMP_OKTA_ACCESS_TOKEN:
      return { ...state, tempOktaAccessToken: action.tempOktaAccessToken }
    case UserConstants.SET_PRIVILEGES:
      return { ...state, privileges: action.privileges }
    default:
      return state
  }
}
